export default {
  title: 'HubRise',
  setup: {
    description: 'Comparte datos con otras aplicaciones.',
  },
  form: {
    is_menus_sync_enabled: 'Sincronizar menú',
    is_inventory_sync_enabled: 'Sincronizar inventario',
    is_opening_hours_sync_enabled: 'Sincronizar horario de apertura',
    is_order_acceptance_mode_sync_enabled: 'Sincronizar estado ocupado / pausado',
    variant_ref: 'Variante de menú',
    variant_ref_default: 'Predeterminado',
  },
  tabs: {
    settings: 'Ajustes',
    service_types: 'Tipos de servicio',
    payments: 'Pagos',
    charges: 'Cargos',
    deals: 'Ofertas',
    discounts: 'Descuentos',
    customers: 'Clientes',
  },
  customers: {
    description:
      'Elimina los datos de un cliente en HubRise, por ejemplo tras una solicitud de eliminación de datos. Esta acción no se puede deshacer.',
    customer: 'Cliente',
    placeholder: 'Buscar por nombre, correo o teléfono…',
  },
  mapping: {
    description:
      'Asigna cada entidad de {{provider}} a su valor y nombre en HubRise. Deja una fila vacía para usar los valores predeterminados de {{provider}}.',
    entity: '{{provider}}',
    value: 'Valor en HubRise',
    name: 'Nombre en HubRise',
  },
  connecting: {
    title: 'Finalizando la conexión con HubRise…',
    description: 'Esto lleva unos segundos. Mantén esta página abierta.',
    error_title: 'La conexión con HubRise está tardando más de lo esperado',
    error_description:
      'HubRise fue autorizado, pero la conexión aún no está confirmada. Comprueba de nuevo en un momento; si sigue fallando, inicia la conexión de nuevo.',
  },
  buttons: {
    connect: 'Conectar con HubRise',
    check_again: 'Comprobar de nuevo',
    disconnect: 'Desconectar',
    go_to_hubrise: 'Ir a HubRise',
    pull_menus: 'Importar menú',
    pull_inventory: 'Importar inventario',
    save: 'Guardar',
    delete_customer: 'Eliminar cliente',
  },
  toasts: {
    connected: 'HubRise se ha conectado',
    connect_cancelled: 'La conexión con HubRise fue cancelada',
    connect_error: 'Error al iniciar la conexión con HubRise',
    connect_timeout: 'La conexión con HubRise aún no pudo confirmarse',
    local_changes_replaced:
      'Los ajustes de HubRise se actualizaron en otro lugar; tus cambios sin guardar fueron reemplazados',
    disconnect_success: 'HubRise se ha desconectado',
    disconnect_error: 'Error al desconectar HubRise',
    pull_menus_success: 'La sincronización del menú ha comenzado',
    pull_menus_error: 'Error al importar el menú',
    pull_inventory_success: 'La sincronización del inventario ha comenzado',
    pull_inventory_error: 'Error al importar el inventario',
    save_success: 'Los ajustes de HubRise se han guardado',
    save_error: 'Error al guardar los ajustes de HubRise',
    load_customers_error: 'Error al cargar los clientes',
    delete_customer_success: 'Se ha solicitado la eliminación de los datos del cliente',
    delete_customer_error: 'Error al eliminar los datos del cliente',
  },
  delete_customer_confirm: {
    title: '¿Eliminar este cliente de HubRise?',
    description: 'Los datos del cliente se eliminarán en HubRise. Esta acción no se puede deshacer.',
    ok: 'Eliminar',
    cancel: 'Cancelar',
  },
  disconnect_confirm: {
    title: '¿Desconectar HubRise?',
    description: 'Esto dejará de sincronizar menús, inventario y pedidos con HubRise.',
    ok: 'Desconectar',
    cancel: 'Cancelar',
  },
  connected: {
    title: 'Conectado a HubRise',
    description: 'Tu cuenta de HubRise está vinculada correctamente.',
    account: 'Cuenta',
    location: 'Ubicación',
    catalog: 'Catálogo',
    customer_list: 'Lista de clientes',
  },
};
